import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetFamilies = async (
  setLoading,
  pageNumber,
  searchTerm,
  institutionId,
  totalPerPage = 10,
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(
      `${apiConfig.baseURL}/family/${institutionId}`,
      {
        headers: apiConfig.headers,
        params: { page: pageNumber, totalPerPage, searchKey: searchTerm },
      }
    );

    return result;
  } catch (error) {
    console.error("Error fetching families:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIDeleteFamily = async (
  familyId,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/family`, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: { familyId, institutionId },
    });

    return result;
  } catch (error) {
    console.error("Error deleting family:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateFamily = async (
  familyData,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    const result = await axios.patch(
      `${apiConfig.baseURL}/family`,
      familyData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error editing/creating family:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateFamilySubscription = async (
  familyId,
  subscriptionPayload,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    const result = await axios.patch(
      `${apiConfig.baseURL}/family/${institutionId}/${familyId}/subscription`,
      subscriptionPayload,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );
    return result;
  } catch (error) {
    console.error("Error updating family subscription:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateParentStatus = async (
  parentId,
  status,
  token,
  institutionId
) => {
  try {
    const apiConfig = getApiConfig();

    const body = {
      status: status.toLowerCase(),
    };

    const result = await axios.patch(
      `${apiConfig.baseURL}/admin/parent/${parentId}/status`,
      body,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      }
    );

    return result;
  } catch (error) {
    console.error(`Error updating status for parent ${parentId}:`, error);
    return error;
  }
};

export const APIBulkImportFamilies = async (
  csvFile,
  setLoading,
  institutionId,
  token,
  sendEmail = true
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    
    // Create FormData
    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("institutionId", institutionId);
    formData.append("sendEmail", sendEmail);

    const result = await axios.post(
      `${apiConfig.baseURL}/family/bulk-import`,
      formData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return result;
  } catch (error) {
    console.error("Error bulk importing families:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIUpdateEmailStatus = async (
  csvFile,
  setLoading,
  institutionId,
  token
) => {
  setLoading(true);
  try {
    const apiConfig = getApiConfig();
    
    // Create FormData
    const formData = new FormData();
    formData.append("file", csvFile);
    formData.append("institutionId", institutionId);

    const result = await axios.patch(
      `${apiConfig.baseURL}/family/bulk-import/update-email-status`,
      formData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return result;
  } catch (error) {
    console.error("Error updating email status:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
